import React, { useState, useEffect, useRef } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Row,
  Button,
  Table,
  Space,
  Tag,
  Modal,
  Input,
  Typography,
} from "antd";
import {
  DownloadOutlined,
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  ClearOutlined,
  SearchOutlined
} from "@ant-design/icons";
import "../../Dashboard/index.css";
import { isEmpty } from "lodash";
import BreadcrumbComponent from "../../../components/BreadCrumb";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../store/Location/actions";
import SimpleReactValidator from "simple-react-validator";
import api from "../../../helpers";
import { toast, ToastContainer } from "react-toastify";

const BCrumb = [{ to: "/", title: "Home" }, { title: "Country" }];

const CountryTab = () => {
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalType, setModalType] = useState("");
  const [disabled, setDisabled] = useState(false);
  //initial data fetch
  useEffect(() => {
    dispatch(actions.loadCountry({status:"BOTH"}));
  }, [dispatch]);
  //simple validator
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = React.useState();

  //data from reducer
  const update = useSelector((country) => country.Location);
  const { countryList = [] } = update;
  const [searchInput, setSearchInput] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  //initial country
  const [masterData, setMasterData] = useState({
    country: "",
    description: "",
  });
  const handleChange = (e) => {
    setMasterData({ ...masterData, [e.target.name]: e.target.value });
  };

  //clear
  const handleClear = (e) => {
    e.preventDefault();
    setMasterData({
      country: "",
      description: "",
    });
    setSearchInput("");
    setIsEdit(false);
    simpleValidator.current.hideMessages();
    forceUpdate(prev => prev + 1);
    dispatch(actions.loadCountry({status:"BOTH"}));
  };
  // modal handling
  const showModalOpen = (type) => {
    setModalType(type);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setModalType("");
  };
  const [isEdit, setIsEdit] = useState(false);
  const [stateId, setStateId] = useState();
  //table columns
  const columns = [
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          S.No
        </span>
      ),
      dataIndex: "sno",
      width: 5,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Action</span>,
      dataIndex: "action",
      width: 70,
      render: (_, record) => (
        <Space style={{ gap: "8px" }}>
          {/* Edit Button */}
          <Button
            style={{
              background: "#34c38f",
              border: "none",
              minWidth: 30,
              height: 30,
              padding: "2px 4px",
              fontSize: "0.75rem",
            }}
            onClick={() => {
              setMasterData({
                country: record.countryName,
                description: record.description
              })
              setIsEdit(true);
              setStateId(record._id);
            }}
          >
            <EditOutlined style={{ color: "#fff", fontSize: 14 }} />
          </Button>

          {/* Delete Button */}
          <Button
            style={{
              background: "#f46a6a",
              border: "none",
              minWidth: 30,
              height: 30,
              padding: "2px 4px",
              fontSize: "0.75rem",
            }}
            onClick={() => {
              showModalOpen("delete");
              setStateId(record._id);
              setSelectedRow([]);
            }}
          >
            <DeleteOutlined style={{ color: "#fff", fontSize: 14 }} />
          </Button>
        </Space>
      ),
    },
    {
      title: <span className="poppins-txt">Country Name</span>,
      dataIndex: "countryName",
      width: 130,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Description</span>,
      dataIndex: "description",
      width: 130,
      className: "poppins-txt-lg",
    },
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          Status
        </span>
      ),
      dataIndex: "status",
      width: 100,
      render: (status) => {
        const isActive = status === 1;
        return (
          <Tag
            style={{
              backgroundColor: isActive ? "#e6f4d7" : "#fae1e1",
              color: isActive ? "#34c38f" : "#f46a6a",
              fontWeight: 500,
              width: 60,
              height: 20,
              paddingTop: "2px",
              fontSize: "11px",
              textAlign: "center",
              lineHeight: "16px",
              borderRadius: 4,
              border: "none",
              fontFamily: "Poppins",
            }}
          >
            {isActive ? "Active" : "Inactive"}
          </Tag>
        );
      },
    },
  ];
  // table datas functionality
  const tableData = !isEmpty(countryList)
    ? countryList.map((data, index) => {
      return {
        _id: data._id,
        sno: index + 1,
        countryName: data.country || "--",
        description: data.description || "--",
        status: data.status,
        editData: data,
      };
    })
    : [];

  const handleUpdateStatus = (statusType) => {
    setDisabled(true); // Disable the button
    setTimeout(() => {
      setDisabled(false); // Re-enable after 4 seconds
    }, 4000);
  
    const statusMap = {
      delete: 3,
      active: 1,
      inactive: 2,
    };

    const toastMessage = {
      delete: "Country deleted successfully",
      active: "Country activated successfully",
      inactive: "Country deactivated successfully",
    };

    const statusValue = statusMap[statusType];
    if (!statusValue) return;
    const id = !isEmpty(selectedRow) ? selectedRow : [stateId];
    const payload = {
      id: id, // use selectedRow instead of hardcoded ID
      status: statusValue,
    };

    api
      .post("/protected/deletecountry", payload)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(actions.loadCountry({status:"BOTH"}));
          toast.success(toastMessage[statusType], { containerId: "toast-2" });
          setSelectedRow([]);
          handleModalClose();
        } else {
          toast.warning(response?.data?.msg || "Unexpected response", { containerId: "toast-2" });
        }
        return response.data;
      })
      .catch((err) => {
         setSelectedRow([]);
          handleModalClose();
        const errorMsg =
         err?.response?.data?.error || err?.response?.data?.message ||
          "An error occurred while updating the employee status";
        toast.error(errorMsg, { containerId: "toast-2" });
        return Promise.reject(err);
      });
  };
  // submit data
  const handleSubmit = (e) => {
    e.preventDefault();

    setDisabled(true); // Disable the button
    setTimeout(() => {
      setDisabled(false); // Re-enable after 4 seconds
    }, 4000);
    const payload = {
      country: masterData.country,
     ...(masterData.description && { description: masterData.description })
    };
    if (simpleValidator.current.allValid()) {
      setSearchLoading(true);

      setTimeout(() => {
        setSearchLoading(false);
      }, 500);
      const endpoint = isEdit
        ? `/protected/updatecountry/${stateId}`
        : "/protected/addcountry";

      api
        .post(endpoint, payload)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            dispatch(actions.loadCountry({status:"BOTH"}));
            toast.success(
              isEdit ? "Country updated successfully" : "Country added successfully", { containerId: "toast-2" }
            );
            setMasterData({
              country: "",
              description: "",
            });
          } else {
            toast.warning(response?.data?.msg || "", { containerId: "toast-2" });
          }
          setIsModalVisible(false);

        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.message ||
            `An error occurred while ${isEdit ? "updating" : "adding"
            } the country`;

          toast.error(errorMsg, { containerId: "toast-2" });
        });
    } else {
      simpleValidator.current.showMessages(); // Show validation messages
      forceUpdate(1);
    }
  };
  // search
  const handleSearch = () => {
    const payload = {
      search: searchInput,
      status:"BOTH"
    };
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);
    dispatch(actions.loadCountry(payload));
  };
  //download csv
  const [downloadLoader, setDownloadLoader] = useState(false);
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });
    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const exportToCsv = () => {
    setSearchLoading(true);
    setDownloadLoader(true);
    setTimeout(() => {
      setSearchLoading(false);
      setDownloadLoader(false);
    }, 500);
    const headers = [
      "S.No",
      "Country Name",
      "Description",
      "Status"
    ];

    const rows = tableData.map((item) => [
      item.sno,
      item.countryName,
      item.description,
      item.status === 1 ? "Active" : "Inactive"
    ]);

    const csvContent = [
      headers.join(","), // header row
      ...rows.map((row) => row.join(",")), // each data row
    ].join("\n");

    downloadFile({
      data: csvContent,
      fileName: "country-list.csv",
      fileType: "text/csv",
    });
  };

  return (
    <>
      <div className="pl-5">
        <MetaTags>
          <title>Location | Mequals</title>
        </MetaTags>
      </div>
      <Row>
        <BreadcrumbComponent title="Country" items={BCrumb} />
      </Row>

      <div
        style={{
          background: "#ffffff",
          margin: "4px 8px 4px 8px", // top, right, bottom, left
          padding: "16px",
          borderRadius: "8px 8px 0px 0px",
        }}
      >
        <Row gutter={[16, 16]} style={{ marginTop: "2px" }}>
          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <Typography className="poppins-txt">
              Country Name
              <span style={{ color: "red", marginLeft: "2px" }}>*</span>
            </Typography>
            <Input
              placeholder="Enter country name"
              allowClear
              className="custom select"
              style={{ width: "100%", fontFamily: "Poppins", marginTop: "5px" }}
              name="country"
              value={masterData.country}
              onChange={(e) => {
                handleChange(e);
              }}
              type="text"
              autoComplete="off"
            />
            <span
              style={{
                color: "#ef3022",
                fontSize: "11px",
                marginTop: "8px",
                fontFamily: "poppins",
                display: "block",
              }}
            >
              {simpleValidator.current.message(
                "country",
                masterData.country,
                "required"
              )}
            </span>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <Typography className="poppins-txt">  Description </Typography>

            <Input
              placeholder="Enter description"
              allowClear
              className="custom-select"
              style={{ width: "100%", fontFamily: "Poppins", marginTop: "5px" }}
              name="description"
              value={masterData.description}
              onChange={(e) => handleChange(e)}
              type="text"
              autoComplete="off"
            />

          </Col>

          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <div
              className="mt-1"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                className="custom-btn"
                size="middle"
                type="primary"
                style={{ marginRight: "12px" }}
                onClick={handleSubmit}
                disabled={disabled}
              >
                {isEdit ? "Update" : (<span><PlusOutlined></PlusOutlined>Add</span>)}
              </Button>
              <Button
                className="custom-btn"
                style={{ background: "#FCE05A", color: "white" }}
                size="middle"
                htmlType="submit"
                onClick={handleClear}
              >
                <ClearOutlined />
                Clear
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      <div
        style={{
          background: "#ffffff",
          margin: "20px 8px 15px 8px",
          padding: "16px",
        }}
      >
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: 16 }}
        >
          <Col>
            <Input
              placeholder="Search..."
              allowClear
              style={{ width: 250, fontFamily: "Poppins" }}
              name="searchInput"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              type="text"
              autoComplete="off"
            />

            <Button
              icon={<SearchOutlined />}
              type="primary"
              style={{ marginLeft: 8 }}
              onClick={handleSearch}
            />
          </Col>

          <Col>
            <Button
              className="custom-btn"
              size="medium"
              type="primary"
              icon={<DownloadOutlined />}
              onClick={exportToCsv}
              loading={downloadLoader}

            >
              Download
            </Button>
          </Col>
        </Row>
        <Table
          loading={searchLoading}
          columns={columns}
          dataSource={tableData}
          className="poppins-txt"
          rowKey={(record) => record._id}
          rowClassName={"text-[12px]"}
          sortDirections={["ascend", "descend"]}
          showSorterTooltip={"sorter-icon"}
          rowSelection={{
            selectedRowKeys: selectedRow,
            onSelectAll: (selected, selectedRows) => {
              const newSelecteds = selected
                ? selectedRows.map((n) => n._id)
                : [];
              setSelectedRow(newSelecteds);
            },
            onSelect: (record, selected) => {
              let newSelecteds = selected
                ? [...selectedRow, record._id]
                : selectedRow.filter((id) => id !== record._id);
              setSelectedRow(newSelecteds);
            },
          }}
          scroll={{ x: 505 }}
        />

        <Space size={4}>
          <Button
            style={{
              marginTop: "20px",
              marginRight: "12px",
              background: "#f46a6a",
            }}
            type="primary"
            size="medium"
            className="custom-btn"
            onClick={() => showModalOpen("delete")}
          >
            Delete
          </Button>

          <Button
            style={{
              marginTop: "20px",
              background: "#34c38f",
              marginRight: "12px",
            }}
            type="primary"
            size="medium"
            className="custom-btn"
            onClick={() => showModalOpen("active")}
          >
            Active
          </Button>

          <Button
            style={{
              marginTop: "20px",
            }}
            type="primary"
            size="medium"
            className="custom-btn"

            onClick={() => showModalOpen("inactive")}
          >
            Inactive
          </Button>
        </Space>

        <Modal
          open={isModalVisible}
          onCancel={handleModalClose}
          title={"Confirmation"}
          cancelText="Cancel"
          className="poppins-txt custom-active-modal"
          centered
          width={450}
          footer={null} // Remove the default footer
        // style={{ padding: 0, marginLeft: "600px" }} // Remove padding from modal
        >
          <div className="custom-modal-content">
            <p>Are you sure you want to {modalType} this country?</p>
          </div>

          {/* Custom footer with cancel and confirm buttons */}
          <div
            className="custom-modal-footer"
            style={{
              borderTop: "1px solid #ccc",
              padding: "10px 16px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              className="custom-btn"
              onClick={handleModalClose}

              style={{
                backgroundColor: "#f46a6a",
                color: "#fff",
                border: "none",
                marginRight: "10px",
              }}
            >
              Close
            </Button>
            <Button
              className="custom-btn"
              disabled={disabled}
              // onClick={handleModalClose}
              onClick={() => handleUpdateStatus(modalType)}
              style={{
                backgroundColor: "#34c38f",
                color: "#fff",
                border: "none",
              }}
            >
              Confirm
            </Button>
          </div>
        </Modal>

        <ToastContainer
          containerId="toast-2"
          position="top-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          style={{
            fontSize: "12px",
          }}
          pauseOnHover
          theme="dark"
        />
      </div>
    </>
  );
};
//CountryTab
export default CountryTab;
